import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Projects from "./Projects";
import Loader from "../../common/Loader";

const ProjectsPage = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const AZURE_BASE_URL =
    "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/projects/windows/";

  const images = [
    `${AZURE_BASE_URL}CHL00701-HDR.jpg`,
    `${AZURE_BASE_URL}CHL00658-HDR.jpg`,
    `${AZURE_BASE_URL}CHL00625-HDR.jpg`,
  ];

  useEffect(() => {
    const allImages = [...images];
    let loaded = 0;

    allImages.forEach((src) => {
      const img = new Image();
      img.onload = img.onerror = () => {
        console.log("Loaded:", src);
        loaded++;
        if (loaded === allImages.length) setIsLoading(false);
      };
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <AnimatePresence>{isLoading && <Loader />}</AnimatePresence>

      {!isLoading && (
        <div className="text-white bg-transparent relative scroll-mt-24 animate-[page-in_.35s_ease]">
          <section className="relative w-full h-[60vh] overflow-hidden flex items-center justify-start">
            <AnimatePresence mode="wait">
              <motion.img
                key={currentImage}
                src={images[currentImage]}
                alt="Projects"
                className="absolute inset-0 w-full h-full object-cover"
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.6 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
              />
            </AnimatePresence>

            <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent" />

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="relative z-10 container"
            >
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold max-w-3xl">
                Architectural Projects
              </h1>
              <p className="mt-4 text-white/80 text-base sm:text-lg max-w-xl leading-relaxed">
                Explore our diverse portfolio — from luxury villas to commercial
                facades — each project showcases precision engineering and
                timeless design using our premium aluminium systems.
              </p>
            </motion.div>
          </section>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="py-12"
          >
            <Projects />
          </motion.div>
        </div>
      )}
    </>
  );
};

export default ProjectsPage;
